"use client";

import React, { useState } from "react";
import {
  Box,
  Button,
  Card,
  Chip,
  Grow,
  Icon,
  IconButton,
  InputAdornment,
  LinearProgress,
  Stack,
  SwipeableDrawer,
  TextField,
  Typography,
} from "@mui/material";
import Arrow2DownIcon from "@/app/_components/Icons/Arrow2DownIcon";
import { Close } from "@mui/icons-material";
import { Color } from "@/__generated__/sdk";
import { useSiteSearchContext } from "./SiteSearchContext";
import _ from "lodash";
import { NumericFormatToman } from "@/app/_components/NumericFormatToman";

function PriceRange({ handleClose }: { handleClose: () => void }) {
  const { isPending, minPrice, maxPrice, handlePriceRangeRemove, handlePriceRangeChange } = useSiteSearchContext();
  const hasSelected = Boolean(minPrice || maxPrice);
  const [minPriceValue, setMinPriceValue] = React.useState<number | null | undefined>(minPrice);
  const [maxPriceValue, setMaxPriceValue] = React.useState<number | null | undefined>(maxPrice);
  return (
    <>
      <Box sx={{ display: "flex", width: "100%", p: 2, overflowY: "auto", flexGrow: 1, alignItems: "start" }}>
        <Stack spacing={{ xs: 1, sm: 1 }} sx={{ px: 1, width: "100%" }}>
          <Stack direction="row" sx={{ width: "100%" }} alignItems={"center"} gap={2} justifyContent={"space-between"}>
            <TextField
              placeholder="از"
              InputProps={{
                inputComponent: NumericFormatToman as any,
                endAdornment: (
                  <InputAdornment position={"end"}>
                    <Typography variant={"body2"}>تومان</Typography>
                  </InputAdornment>
                ),
              }}
              // sx={{ minWidth: 90, maxWidth: 190 }}
              value={minPriceValue}
              onChange={(e) => {
                setMinPriceValue(e.target.value ? Number(e.target.value) : null);
              }}
              size="medium"
              variant="outlined"
            />
            <TextField
              placeholder="تا"
              InputProps={{
                inputComponent: NumericFormatToman as any,
                endAdornment: (
                  <InputAdornment position={"end"}>
                    <Typography variant={"body2"}>تومان</Typography>
                  </InputAdornment>
                ),
              }}
              // sx={{ minWidth: 90, maxWidth: 190 }}
              value={maxPriceValue}
              onChange={(e) => {
                setMaxPriceValue(e.target.value ? Number(e.target.value) : null);
              }}
              size="medium"
              variant="outlined"
            />
          </Stack>
          {/* <Slider
                  step={1000}
                  value={value2}
                  max={MAX}
                  onChangeCommitted={(event: React.SyntheticEvent | Event, value: number | Array<number>) => {
                    if (Array.isArray(value)) {
                      const [min, max] = value;
                      if (min > 0) {
                        setMinPriceValue(min);
                      } else if (min === 0) {
                        setMinPriceValue(undefined);
                      }
                      if (max !== MAX) {
                        setMaxPriceValue(max);
                      } else {
                        setMaxPriceValue(undefined);
                      }
                    }
                  }}
                  slots={{
                    valueLabel: ValueLabelComponent,
                  }}
                  onChange={handleChange2}
                  // valueLabelFormat={valuetext}
                  valueLabelDisplay="auto"
                  color="secondary"
                /> */}
          <Stack direction="row" alignItems={"center"} justifyContent={"space-between"}>
            <Typography variant="body2">ارزان‌ترین</Typography>
            <Typography variant="body2">گران‌ترین</Typography>
          </Stack>
        </Stack>
      </Box>
      <Box
        sx={{
          flexShrink: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: hasSelected ? "space-between" : "end",
          gap: 1,
          p: 2,
        }}
      >
        {hasSelected && (
          <Button
            variant="outlined"
            onClick={() => {
              handlePriceRangeRemove();
              handleClose();
            }}
            disableElevation
            sx={{ borderRadius: 2 }}
            startIcon={<Close />}
          >
            حذف فیلتر
          </Button>
        )}
        <Box sx={{ flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "end", gap: 1 }}>
          <Button
            onClick={() => {
              handleClose();
            }}
          >
            انصراف
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              handlePriceRangeChange(minPriceValue, maxPriceValue);
              handleClose();
            }}
            disableElevation
            sx={{ borderRadius: 2 }}
          >
            اعمال فیلر
          </Button>
        </Box>
      </Box>
    </>
  );
}

export default function MobileFilterPriceRangeChip() {
  const { isPending, minPrice, maxPrice, handlePriceRangeRemove } = useSiteSearchContext();
  const [open, setOpen] = React.useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  const hasSelected = Boolean(minPrice || maxPrice);
  return (
    <>
      <Chip
        variant={hasSelected ? "filled" : "outlined"}
        onClick={() => {
          setOpen(true);
        }}
        {...(hasSelected && {
          color: "primary",
          onDelete: () => {
            handlePriceRangeRemove();
          },
        })}
        label={
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            {/* <Icon sx={{ fontSize: 14 }}>
              <SortIcon />
            </Icon> */}
            <Typography variant="body2">محدوده قیمت</Typography>
            {/* <Icon sx={{ fontSize: 14 }}>
              <Arrow2DownIcon />
            </Icon> */}
          </Box>
        }
      ></Chip>

      <SwipeableDrawer
        ModalProps={{
          keepMounted: false,
        }}
        PaperProps={{
          sx: {
            height: "70vh",
            borderTopLeftRadius: 4 * 4,
            borderTopRightRadius: 4 * 4,
          },
        }}
        anchor={"bottom"}
        open={open}
        onClose={() => {
          handleClose();
        }}
        onOpen={() => {}}
        disableDiscovery={true}
        hysteresis={0}
        disableSwipeToOpen={true}
        swipeAreaWidth={0}
      >
        <Stack sx={{ height: "100%", flexGrow: 1 }}>
          <Stack sx={{ flexShrink: 0 }}>
            <Grow in={isPending}>
              <LinearProgress variant="indeterminate" color="secondary" />
            </Grow>
          </Stack>
          <Stack direction={"row"} sx={{ mt: 1, flexShrink: 0 }} alignItems={"center"} justifyContent={"center"}>
            <Box width={"45px"} height={"5px"} sx={{ borderRadius: 50, backgroundColor: "grey.100" }}></Box>
          </Stack>
          <Box sx={{ flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "space-between", p: 2 }}>
            <Typography variant="h4"> محدوده قیمت </Typography>
            <IconButton
              onClick={() => {
                handleClose();
              }}
            >
              <Close />
            </IconButton>
          </Box>
          <PriceRange handleClose={handleClose} />
        </Stack>
      </SwipeableDrawer>
    </>
  );
}
